import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 分页获取播放列表
 * @param {Object} data 参数
 * @returns
 */
export function getPlayList (data) {
  return request.post('/ooh-msp/v1/playList/getPlayList', qs.stringify(data))
}

/**
 * 分页查询上传记录
 * @param {Object} data 参数
 * @returns
 */
export function getPlayListRecord (data) {
  return request.post('/ooh-msp/v1/playList/getPlayListRecord', qs.stringify(data))
}
